// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"1e888369","166":"8007856f","195":"dd812db4","335":"d87a6e30","376":"5cddd65b","507":"8122f246","582":"8122f246","745":"8122f246","778":"634a78b4","987":"8007856f"}[chunkId] + ".chunk.css";
};